import React from 'react';
import { Clock, Target, Heart, Award } from 'lucide-react';
import { differentials } from '../data/mock';

const iconMap = {
  Clock,
  Target,
  Heart,
  Award
};

const DifferentialsSection = () => {
  return (
    <section className="section-spacing bg-[#F7FAFC]">
      <div className="container-main">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <span className="caption mb-3 block">Diferenciais</span>
            <h2 className="heading-1 mb-4">Por que escolher a eLauria?</h2>
            <p className="body-medium mb-8">
              Nossa atuação é pautada por valores que garantem excelência 
              em cada projeto e satisfação de cada cliente.
            </p>

            {/* Differentials List */}
            <div className="space-y-5">
              {differentials.map((item) => {
                const IconComponent = iconMap[item.icon];
                return (
                  <div key={item.id} className="flex gap-4">
                    <div className="icon-box flex-shrink-0">
                      {IconComponent && <IconComponent size={18} />}
                    </div>
                    <div>
                      <h3 className="font-semibold text-[#0F172A] text-sm mb-1">{item.title}</h3>
                      <p className="text-[#64748B] text-sm leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Image - DIFERENTE da Home: equipe analisando dados */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-white shadow-sm border border-[#E2E8F0]">
              <img 
                src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80" 
                alt="Equipe analisando resultados"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Stats Card */}
            <div className="absolute -bottom-4 -right-4 bg-[#3E6B2A] text-white rounded-lg p-5 shadow-lg">
              <span className="text-3xl font-bold text-white">35+</span>
              <p className="text-xs text-white mt-0.5">anos de atuação</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DifferentialsSection;
